import React from 'react';
import './CouponsItem.less';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import { formatDate } from '../../utils';
import {TransformFont} from '../../components'

interface couponsItemPropType {
    prefixCls?: string;
    imgBg: string; // 优惠券背景颜色
    text: string; // 文案
    style?: any; // 样式
    isCheckedBox?: boolean; // 是否可以选中
    isShowBg?: boolean; // 是否显示右上角背景
    onCheckBoxClick?: any; // 选中事件
    data?: any; // 每张优惠券数据
    timeType?: boolean; // 展示时间方式
    onHandleClick?: (type: string, data: any) => void; // 点击事件
    textWidth?: any;
}

/**
 * 优惠券列表条目
 * @class CouponsItem
 * @extends {React.Component<couponsItemPropType, any>}
 */
@observer
class CouponsItem extends React.Component<couponsItemPropType, any> {
    static defaultProps = {
        prefixCls: 'couponsItem',
        isCheckedBox: false,
        isShowBg: false,
        imgBg: '',
        text: '',
        timeType: false
    };

    @autobind
    private setClass(text: string): any {
        const {prefixCls} = this.props;
        switch (text) {
            case '去使用':
            case '立即使用':
                return `${prefixCls}-btn-use`;
            case '立即领取':
                return `${prefixCls}-btn-receive`;
            case '已使用':
                return `${prefixCls}-isUse`;
            case '已被领取':
                return `${prefixCls}-btn-gray `;
            default:
                return ``
        }
    }

    @autobind
    private setClassBg(text: string): any {
        const {prefixCls} = this.props;
        switch (text) {
            case '已使用':
                return `${prefixCls}-isUse`;
            case '已过期':
                return `${prefixCls}-is_no_use`;
            case '已领取':
                return `${prefixCls}-have-received`;
            case '已抢光':
                return `${prefixCls}-loot-all`;
            default:
                return ``
        }
    }

    @autobind
    private setImgBg(imgBg: string): string {
        const {prefixCls} = this.props;
        switch (imgBg) {
            case '未使用':
            case '可用':
            case '立即领取':
            case '立即使用':
            case '已领取' :
                return `${prefixCls}-item`;
            case '已使用':
            case '已过期':
            case '不可用':
            case '已被领取':
            case '已抢光':
                return `${prefixCls}-item-no`;
            default:
                return `${prefixCls}-item`;
        }
    }

    private _showTime(data: any): any {
        if (data.validateType === 1) {
            return `领取当天有效`
        } else if (data.validateType === 2) {
            return `领取后有效期${data.validateDay}天`
        } else {
            return (
                <div>
                    {formatDate(data.startTime, 'yyyy.MM.dd hh:mm')}
                    至
                    {formatDate(data.endTime, 'yyyy.MM.dd hh:mm')}
                </div>
            )
        }
    }

    render() {
        const {prefixCls, text, imgBg, style, isShowBg, isCheckedBox, onCheckBoxClick, data, onHandleClick, timeType, textWidth} = this.props;
        return (
            <div className={this.setImgBg(imgBg)} style={style}>
                <div className={`${prefixCls}-itemLeft`}>
                    <div className={`${prefixCls}-itemPrice`}>
                        <span>￥</span>
                        <TransformFont
                            font={data.couponMoney}
                            firstSize={'3.6rem'}
                            secondsSize={'1.4rem'}
                            class={`${prefixCls}-itemPrice-font`}
                        />
                    </div>
                    <p className={`${prefixCls}-itemSubtraction`}>满￥{data.useLimit}可用</p>
                </div>
                <div className={`${prefixCls}-itemRight`}>
                    <p className={`${prefixCls}-itemRight-title`} style={{width: textWidth}}>{data.couponName}</p>
                    <p className={`${prefixCls}-shop_name`}>使用店铺：{data.storeName || data.storeKepperName || '--'}</p>
                    <p className={`${prefixCls}-itemRight-msg`}>{data.couponDesc}</p>
                    <div className={`${prefixCls}-itemRight-btm`}>
                        <span className={`${prefixCls}-time`}>
                            {
                                timeType ?
                                    this._showTime(data)
                                    :
                                    <div>
                                        {formatDate(data.startTime, 'yyyy.MM.dd hh:mm')}
                                        至
                                        {formatDate(data.endTime, 'yyyy.MM.dd hh:mm')}
                                    </div>
                            }
                        </span>
                        {text && text !== '已过期' && text !== '已使用' && text !== '已领取' && text !== '已抢光' &&
                        <span className={`${prefixCls}-btn ` + this.setClass(text)} onClick={() => {
                            onHandleClick && onHandleClick(text, data);
                        }}>{text}</span>}
                    </div>
                </div>
                {isShowBg && <div className={`${prefixCls}-warning ` + this.setClassBg(text)}/>}
                {
                    isCheckedBox && (
                        <div
                            className={`${prefixCls}-checkedBox ` + (data.isChecked ? `${prefixCls}-checkedBoxAct` : `${prefixCls}-checkedBoxNo`)}
                            onClick={() => {
                                onCheckBoxClick(data.userCouponRidCode);
                            }}
                        />
                    )
                }
            </div>
        );
    }
}

export default CouponsItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/couponsItem/CouponsItem.tsx